
import { computed, defineComponent } from "vue-demi";

export default defineComponent({
  name: "NewPopup",

  props: {
    to: {
      type: String,
      default: "root",
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
    okLabel: {
      type: String,
      default: "Next",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue", "cancel", "ok"],

  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    // const close = () => {
    //   isOpen.value = false;
    // };

    const onCancel = () => {
      emit("cancel");

      // close();
    };

    const onOk = () => {
      emit("ok");

      // close();
    };

    return {
      isOpen,
      onCancel,
      onOk,
    };
  },
});
